import api from '@/services/api/api';

export const useArticlesCategories = (
  params = {
    filters: {},
  },
) => {
  const rubrics = useQuery(
    ['rubrics', params.filters],
    async () => {
      const { data } = await api.articles.getArticlesCategories(
        toValue(params.filters),
      );

      return data;
    },
    {
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await rubrics.suspense();
  });

  return {
    rubrics,
  };
};
